export default __webpack_public_path__ + "static/media/less-circle.1c909dfa.svg";